/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignRoleToUserRequestDto
 */
export interface AssignRoleToUserRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AssignRoleToUserRequestDto
     */
    roleId: string;
}

/**
 * Check if a given object implements the AssignRoleToUserRequestDto interface.
 */
export function instanceOfAssignRoleToUserRequestDto(value: object): value is AssignRoleToUserRequestDto {
    if (!('roleId' in value) || value['roleId'] === undefined) return false;
    return true;
}

export function AssignRoleToUserRequestDtoFromJSON(json: any): AssignRoleToUserRequestDto {
    return AssignRoleToUserRequestDtoFromJSONTyped(json, false);
}

export function AssignRoleToUserRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignRoleToUserRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'roleId': json['roleId'],
    };
}

export function AssignRoleToUserRequestDtoToJSON(json: any): AssignRoleToUserRequestDto {
    return AssignRoleToUserRequestDtoToJSONTyped(json, false);
}

export function AssignRoleToUserRequestDtoToJSONTyped(value?: AssignRoleToUserRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleId': value['roleId'],
    };
}

